import { render, staticRenderFns } from "./ttshop_invoicexq.vue?vue&type=template&id=00047d90&scoped=true&"
import script from "./ttshop_invoicexq.vue?vue&type=script&lang=js&"
export * from "./ttshop_invoicexq.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_invoicexq.vue?vue&type=style&index=0&id=00047d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00047d90",
  null
  
)

export default component.exports